import { useEffect, useState } from 'react'
import { useUserstore } from 'src/store/search'
import {
  Pagination,
  Card,
  Col,
  Button,
  Row,
  Spin,
  Tag,
  Select,
  Space,
  Input
} from 'antd'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { Preloader } from 'src/components/preloader'
import { useAuthStore } from 'src/store/auth'
import 'react-photo-view/dist/react-photo-view.css'
import { API } from 'src/API'
import { RemoveModal } from 'src/components/removeModal'
import { Link } from 'react-router-dom'
import { CreateAnnonceModal } from 'src/components/CreateAnnonceModal'
import { UpdateSubscriptionModal } from 'src/components/UpdateSubscriptionModal'
import { CreateUserModal } from 'src/components/CreateUserModal'
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  SearchOutlined
} from '@ant-design/icons'
import { useDebounce } from 'use-debounce'
import { useDictionariesStore } from 'src/store/dictionaries'

export const Compte = () => {
  const { searchData, isLoading, onSearch, searchPagination } = useUserstore(
    (store) => store
  )

  const { loadSubscriptions, subscriptions, loadCategories, categories } = useDictionariesStore(
    (store) => store
  )

  const [sortBy, setSortBy] = useState('name')
  const [sortDirection, setSortDirection] = useState('asc')
  const [search, setSearch] = useState('')

  const [value] = useDebounce(search, 500)

  const { setActiveKeyMainMenu } = useAuthStore((store) => store)

  const handleChange = (value) => {
    setSortBy(value)
  }

  const OPTIONS = [
    { value: 'name', label: 'Name' },
    { value: 'first_name', label: 'First name' },
    { value: 'email', label: 'Email' },
    { value: 'phone', label: 'Phone' },
    { value: 'vat', label: 'VAT' }
  ]

  const handleDirection = () => {
    const newDirection = sortDirection === 'asc' ? 'desc' : 'asc'

    setSortDirection(newDirection)
  }

  useEffect(() => {
    onSearch(1, sortBy, sortDirection, search)
  }, [sortBy, sortDirection, value])

  useEffect(() => {
    if (!subscriptions) loadSubscriptions()
    if (!categories) loadCategories()
    setActiveKeyMainMenu('mainMenu2')
  }, [])

  return (
    <div>
      <h1>Compte</h1>
      <Space wrap>
        <div>
          <p style={{ paddingBottom: 5 }}>Sort By</p>
          <Select
            style={{ width: 200 }}
            value={sortBy}
            onChange={handleChange}
            options={OPTIONS}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5 }}>Search</p>
          <Input
            placeholder='Search...'
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            prefix={<SearchOutlined />}
          />
        </div>
        <div>
          <p
            style={{ paddingBottom: 5, cursor: 'pointer' }}
            onClick={handleDirection}
          >
            Sort Direction
          </p>
          {sortDirection === 'asc' ? (
            <ArrowUpOutlined onClick={handleDirection} />
          ) : (
            <ArrowDownOutlined onClick={handleDirection} />
          )}
        </div>
        <div style={{ paddingTop: 20, paddingLeft: 20 }}>
          <CreateUserModal
            refresh={() => onSearch(1, sortBy, sortDirection, search)}
          />
        </div>
      </Space>
      <div style={{ position: 'relative', padding: '20px 0' }}>
        {isLoading ? <Preloader /> : null}
        {searchData
          ? searchData.map((photo) => (
              <Card key={photo?.id} style={{ margin: '10px 0' }}>
                <Row>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <p style={{ paddingBottom: 5 }}>
                        ID: <Tag color='red'>{photo?.id || '-'}</Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Created at:{' '}
                        <Tag color='green'>
                          {photo?.readable_created_at || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        Updated at:{' '}
                        <Tag color='cyan'>
                          {photo?.readable_updated_at || '-'}
                        </Tag>
                      </p>
                      <p style={{ paddingBottom: 5 }}>
                        VAT: <Tag color='blue'>{photo?.vat || '-'}</Tag>
                      </p>
                      <Link to={`${photo?.id}`}>
                        <Button style={{ marginTop: 10 }} type='primary'>
                          Details
                        </Button>
                      </Link>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <div>
                      <RemoveModal
                        refresh={() =>
                          onSearch(1, sortBy, sortDirection, search)
                        }
                        endpoint={API.COMMON.usersEndpoint}
                        title={'Delete user?'}
                        text={`Are you sure to delete the ${
                          photo?.first_name || ''
                        } ${photo?.name || ''} user?`}
                        id={photo?.id}
                      />
                      <div style={{ paddingTop: 10 }}>
                        <CreateAnnonceModal
                          refresh={() =>
                            onSearch(1, sortBy, sortDirection, search)
                          }
                          endpoint={API.COMMON.annoncesEndpoint}
                          modalTitle={'Create annonce?'}
                          modalText={`Are you sure to create annonce?`}
                          userId={photo?.id}
                          reqType='post'
                          categories={categories}
                          ntftTitle='New Annonce'
                          btnText={`Create annonce`}
                        />
                      </div>
                      <div style={{ paddingTop: 10 }}>
                        <UpdateSubscriptionModal
                          refresh={() =>
                            onSearch(1, sortBy, sortDirection, search)
                          }
                          reqData={photo}
                          id={photo?.id}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <p>Avatar: </p>
                    {photo?.avatar ? (
                      <PhotoProvider>
                        <PhotoView src={photo?.avatar}>
                          <img
                            style={{ margin: 2, maxWidth: 100, maxHeight: 100 }}
                            src={photo?.avatar}
                            alt={photo?.id}
                          />
                        </PhotoView>
                      </PhotoProvider>
                    ) : (
                      '-'
                    )}
                  </Col>
                  <Col
                    xs={24}
                    md={6}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>Name:</p>
                      <p>
                        <b>
                          {photo?.first_name || '-'} {photo?.name || '-'}
                        </b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>address:</p>
                      <p>
                        <b>{photo?.address || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>city:</p>
                      <p>
                        <b>{photo?.city || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>country:</p>
                      <p>
                        <b>{photo?.country || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>phone:</p>
                      <p>
                        <b>{photo?.phone || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>status:</p>
                      <p>
                        <b>{photo?.status || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>tva:</p>
                      <p>
                        <b>{photo?.tva || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>zip:</p>
                      <p>
                        <b>{photo?.zip || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>subscription_type:</p>
                      <p>
                        <b>{photo?.subscription_type || '-'}</b>
                      </p>
                    </div>
                    <div style={{ marginBottom: 10, display: 'flex', gap: 10 }}>
                      <p>count active products:</p>
                      <p>
                        <b>{photo?.count_active_products || '-'}</b>
                      </p>
                    </div>
                    <div style={{ display: 'flex', gap: 10 }}>
                      <p>Email:</p>
                      <p>
                        <b>{photo?.email || '-'}</b>
                      </p>
                    </div>
                  </Col>
                </Row>
              </Card>
            ))
          : null}
      </div>
      {searchPagination ? (
        <Pagination
          defaultCurrent={1}
          current={searchPagination?.current_page}
          total={searchPagination?.total}
          pageSize={searchPagination?.per_page}
          onChange={(newPage) =>
            onSearch(newPage, sortBy, sortDirection, search)
          }
          showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
        />
      ) : null}
    </div>
  )
}
